import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Don't scroll to top if there's a hash in the URL (let the browser handle the anchor)
    if (!hash) {
      // Force 'instant' behavior to avoid jarring visual jumps or conflicting smooth scroll CSS
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }
  }, [pathname, hash]);

  return null;
}
